export { default as useAwardsData } from "./useAwardsData";
